/**
 * Extract feature flags from URL query parameters
 *
 * @return {Object} Object with feature flags as boolean values.
 * @example
 * URL: ?features=enableGamer,enableFacilitator
 * Returns: { enableGamer: true, enableFacilitator: true }
 *
 * URL: ?enableDevelop=true
 * Returns: { enableDevelop: true }
 *
 * URL: ?features=enableDevelop
 * Returns: { enableDevelop: true }
 */
export const getFeatureFlagsFromUrl = () => {
  if (typeof window === 'undefined') return {}
  if (typeof window.location === 'undefined') return {}

  const queryParams = new URLSearchParams(window.location.search)
  const flags: { [flag: string]: boolean } = {}

  // Support ?features=flag1,flag2 format
  const featuresText = queryParams.get('features')
  if (featuresText) {
    featuresText.split(',').forEach((flag) => {
      const trimmed = flag.trim()
      if (trimmed) {
        flags[trimmed] = true
      }
    })
  }

  // Support direct enableDevelop query parameter: ?enableDevelop=true or ?enableDevelop=false
  const enableDevelop = queryParams.get('enableDevelop')
  if (enableDevelop !== null) {
    flags.enableDevelop = enableDevelop.toLowerCase() === 'true'
  }

  return flags
}
